<ng-container>
    <div *ngIf="root && item.visible !== false" class="layout-menuitem-root-text">
        <span>{{ item.label }}</span>
        <i class="layout-menuitem-root-icon pi pi-fw pi-ellipsis-h"></i>
    </div>
    <a *ngIf="(!item.uiSref || item.items) && item.visible !== false"
        (click)="itemClick($event)" (mouseenter)="onMouseEnter()" [ngClass]="item.class"
        [attr.target]="item.target" tabindex="0" pRipple [pTooltip]="item.label"
        [tooltipDisabled]="!(isSlim && root && !active)"
    >
        <i [ngClass]="item.icon" class="layout-menuitem-icon"></i>
        <span class="layout-menuitem-text">{{ item.label }}</span>
    <span *ngIf="item.badge" [ngClass]="item.badgeStyleClass + (item.label === 'eFAACT Checkup' ? ' layout-checkup-menuitem-badge' : ' layout-menuitem-badge')">{{ item.badge }}</span>
        <i class="pi pi-fw pi-angle-down layout-submenu-toggler" *ngIf="item.items"></i>
    </a>
    <a *ngIf="item.uiSref && !item.items && item.visible !== false" (click)="itemClick($event)"
        (mouseenter)="onMouseEnter()" [ngClass]="item.class" [uiSref]="item.uiSref"
        [attr.target]="item.target" tabindex="0" pRipple [pTooltip]="item.label"
        [tooltipDisabled]="!(isSlim && root)"
    >
        <i [ngClass]="item.icon" class="layout-menuitem-icon"></i>
        <span class="layout-menuitem-text">{{ item.label }}</span>
        <span *ngIf="item.badge" [ngClass]="item.badgeStyleClass" class="layout-menuitem-badge">{{ item.badge }}</span>
        <i class="pi pi-fw pi-angle-down layout-submenu-toggler" *ngIf="item.items"></i>
    </a>


    <ul #submenu *ngIf="item.items && item.visible !== false" [@children]="submenuAnimation" (@children.done)="onSubmenuAnimated($event)">
        <ng-template ngFor let-child let-i="index" [ngForOf]="item.items">
            <li app-menuitem [item]="child" [index]="i" [parentKey]="key" [class]="child['badgeClass']"></li>
        </ng-template>
    </ul>
</ng-container>
